import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { friendlyError } from '@/lib/friendlyCodes';

// Day 22 — worker view of feedback about their shifts (Day 13): only items where a response was requested or given.
export default function MyFeedbackPage() {
  const [rows, setRows] = useState(null);
  const [text, setText] = useState({});
  const load = useCallback(() => api.get('/worker-matching/feedback/mine').then((r) => setRows(r.data?.data || [])).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);

  const respond = async (f) => {
    const t = (text[f.id] || '').trim();
    if (!t) { toast.error('Please write your response first'); return; }
    try { await api.post(`/worker-matching/feedback/${f.id}/worker-response`, { text: t }); toast.success('Response sent to the reviewing manager'); setText({ ...text, [f.id]: '' }); load(); } catch (e) { toast.error(friendlyError(e, 'Could not send response')); }
  };

  return (
    <div className="space-y-4" data-testid="my-feedback-page">
      <p className="text-sm text-muted-foreground">When a manager asks for your side of participant feedback, it appears here. Who submitted the feedback is never shown.</p>
      {rows === null && <p className="text-sm text-muted-foreground">Loading…</p>}
      {rows?.length === 0 && <div className="rounded-lg border p-6 text-center text-sm text-muted-foreground" data-testid="my-feedback-empty">No feedback needs your response right now.</div>}
      {(rows || []).map((f) => (
        <div key={f.id} className="rounded-lg border p-4 space-y-2" data-testid={`my-feedback-${f.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
            <span className="font-medium">Shift {f.shiftDate || ''}</span>
            <Badge variant="outline">{String(f.triage_status).replace(/_/g, ' ')}</Badge>
          </div>
          {f.rating && <div className="text-sm">Rating: {f.rating}/5</div>}
          {f.message && <p className="text-sm rounded bg-muted/40 p-2">“{f.message}”</p>}
          {f.workerResponse?.text ? (
            <div className="text-sm"><span className="font-medium">Your response:</span> {f.workerResponse.text}</div>
          ) : f.response_requested ? (
            <div className="space-y-2">
              <Textarea placeholder="Your account of what happened…" value={text[f.id] || ''} onChange={(e) => setText({ ...text, [f.id]: e.target.value })} data-testid={`my-feedback-text-${f.id}`} />
              <Button size="sm" onClick={() => respond(f)} data-testid={`my-feedback-send-${f.id}`}>Send response</Button>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
